module.exports = __webpack_public_path__ + "images/a484d513c54e56ae5c6d89180b1bc410-illu_panelB.svg";